/**
 * Meta ad attribution sent with the checkout request, so the server-side Meta signup event
 * can be matched to the ad click. fbp/fbc come from the Meta pixel cookies set on the
 * marketing site; fbc falls back to the fbclid the ad landing pages forward to /subscribe.
 */
export interface MetaAttribution {
  fbc?: string;
  fbp?: string;
  eventSourceUrl?: string;
}

function readCookie(cookieString: string, name: string): string | undefined {
  for (const part of cookieString.split(";")) {
    const [key, ...rest] = part.trim().split("=");
    if (key === name) {
      const value = rest.join("=");
      try {
        return decodeURIComponent(value) || undefined;
      } catch {
        return value || undefined;
      }
    }
  }
  return undefined;
}

export function getMetaAttribution(
  location: Pick<Location, "origin" | "pathname" | "search"> = window.location,
  cookieString: string = typeof document !== "undefined" ? document.cookie : "",
  now: number = Date.now()
): MetaAttribution {
  const attribution: MetaAttribution = {};

  const fbp = readCookie(cookieString, "_fbp");
  if (fbp) attribution.fbp = fbp;

  const fbcCookie = readCookie(cookieString, "_fbc");
  const fbclid = new URLSearchParams(location.search).get("fbclid")?.trim();
  if (fbcCookie) attribution.fbc = fbcCookie;
  else if (fbclid) attribution.fbc = `fb.1.${now}.${fbclid}`;

  attribution.eventSourceUrl = `${location.origin}${location.pathname}`;
  return attribution;
}
